@if (isgotData) {
<div class="checkout-step checkout-page-container" [ngClass]="!isMobile? 'd-flex':'d-flex flex-column'">
  <app-kbcheckoutstepper [steponeOrg]="stepone" [stepTwo]="stepTwo" [thirdStep]="stepthree"
    [userInWhichStep]="userInWhichStep" [currentCartId]="cartCode"
    [currentB2bUnitSendToWebtrack]="currentB2bUnitSendToWebtrack"
    [ngClass]="!isMobile? 'col-12 col-md-12 col-lg-5':''"></app-kbcheckoutstepper>
  <app-order-summary-right [orderSummary]="orderSummary" [total]="totalAmt" [subTotal]="subTotal"
    [minOrderCharge]="minOrderCharge" [ngClass]="!isMobile? 'col-7':''"></app-order-summary-right>
  @if (activeStep==4) {
  <div class="form-group col-xs-12 col-sm-12 d-none d-sm-none d-md-none d-lg-none">
    <div class="form-check dataProtection">
      <input class="form-check-input" type="checkbox" (click)="placeOrderCheck($event)">
      <label class="form-check-label uid-text">
        {{'common.checkout_summary_placeOrder_readTermsAndConditions'|cxTranslate}} <a
          href="https://n0c357rmy1njbuit2friqwu.blob.core.windows.net/conditionofsale/20200917_EMEA_Y128901_EN_000_Condition_of_Sale_Spain_EN_v1.pdf"
          target="_blank">{{'common.text_training_booking_form_terms_link'|cxTranslate}}</a>
      </label>
    </div>
    <button class="btn btn-primary btn-block place-order" [disabled]="!canPlaceOrder" (click)="placeOrder()">
      {{'common.checkout_summary_placeOrder'|cxTranslate}}
      <img src="/icons/link-white.svg" style="width: 35px;" class="whiteArrow" alt="Link Icon">
    </button>
  </div>
  }
  <div class="col-xs-12 col-sm-12 d-block d-sm-none d-md-block d-lg-none" style="padding: 0;">
    <button class="d-flex align-items-center back-to-cart" [routerLink]="{ cxRoute: 'cart' } | cxUrl">
      <img src="/icons/link_left-blue.svg" class="icon-right" alt="">
      <span>{{'common.checkout_page_back_to_cart'|cxTranslate}}</span>
    </button>
  </div>
</div>
}
@if (activeStep==4) {
<div>
  <div class="help-content col-xs-12 col-sm-12">
    <div [innerHTML]="helpText?.content"></div>
  </div>
</div>
}